// extracted by mini-css-extract-plugin
module.exports = {"textarea":"src-hellospa-foundation-control-textarea-textarea__textarea--3irOe"};